import { useEffect, useState } from "react";
import { getSalePageDetail } from "../api/salePage.api";

export function useSalePage(domain, path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, [domain, path]);

  const load = async () => {
    const result = await getSalePageDetail(domain, path);
    setData(result);
    setLoading(false);
  };

  return { data, loading };
}
